import api from "./api";

const API_URL = "/SmartDelivery";

export const processSmartDelivery = async (parcelId, distances) => {
    const res = await api.post(`${API_URL}/process`, {
        parcelId: Number(parcelId),
        distances,
    });

    return res.data;
}; export const getClientSmartContractByShipmentId = async (shipmentId) => {
    const res = await api.get(`/smartcontract/client/shipment/${shipmentId}`);
    return res.data;
};

export default {
    processSmartDelivery,
    getClientSmartContractByShipmentId,
};